/**
 * @generated SignedSource<<0b8823433b9808cbe88e4c477369c8e0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SparkBalancePillQuery$variables = Record<PropertyKey, never>;
export type SparkBalancePillQuery$data = {
  readonly currentUser: {
    readonly sparkBalance: number | null | undefined;
  } | null | undefined;
};
export type SparkBalancePillQuery = {
  response: SparkBalancePillQuery$data;
  variables: SparkBalancePillQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sparkBalance",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SparkBalancePillQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v0/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "SparkBalancePillQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4bca25c99b39901099dc204505d1bcc6",
    "id": null,
    "metadata": {},
    "name": "SparkBalancePillQuery",
    "operationKind": "query",
    "text": "query SparkBalancePillQuery {\n  currentUser {\n    sparkBalance\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "57885bd329391ba481e24a863c7c6e82";

export default node;
